import { ItemConfigs } from '@/src/pages/channel_list/components/ShopCard/items/itemConfigs';

const ShopCardMv = 'b_waimai_c_overseas_vb9w5duu_mv';

const ShopCardMc = 'b_waimai_c_overseas_vb9w5duu_mc';

export interface LxFilterParams {
  sort_code: string;
  sort_name: string;
  filter_code: string;
  filter_name: string;
}

const Statistics = Mach.requireModule('Statistics');

const shopActivity = {
  fullReduction: 2, // 满减
  fullDiscountActivity: 3, // 满折
  feeFree: 4, // 免配送费
  promoDishes: 18, // 折扣菜
  deliveryActivity: 21, // 配送费活动
};

// 灵犀埋点上报参数处理
export const handleLXParam = (data: any, shop_index: number, bizTraceId: string, lxFilterParams: LxFilterParams) => {
  // 满减活动id
  const full_reduction_activity_id = '-999'; // 后端下发, 此处占位
  // 配送费活动id
  const delivery_activity_id = '-999';
  // 满折活动id
  const full_discount_activity_id = '-999';
  // 折扣菜 id
  const promo_dishes = '-999';

  const logData = data?.logData || {};

  let paramsLxForLogs = {};

  const shopContentVerticalData = data.content || [];
  shopContentVerticalData.forEach((item: any) => {
    item.forEach((subItem: any) => {
      const itemType = subItem.type;
      const ItemModelClass = ItemConfigs[itemType].model;
      const itemModel = new ItemModelClass(subItem?.data);
      const lxParams = itemModel.paramsForLxLog?.();
      if (lxParams) {
        paramsLxForLogs = { ...paramsLxForLogs, ...lxParams };
      }
    });
  });

  return {
    full_reduction_activity_id,
    delivery_activity_id,
    full_discount_activity_id,
    promo_dishes,
    average_price: '-999',
    biz_trace_id: bizTraceId || '-999',
    currency_type: '-999',
    delivery_price: '-999',
    delivery_time: '-999',
    filter_code: lxFilterParams.filter_code || '-999',
    filter_name: lxFilterParams.filter_name || '-999',
    min_price: data?.minCostPrice?.displayAmount ?? '-999',
    picture_url: data?.shopMainPicUrl || '-999',
    shop_distance: '-999',
    shop_id: '-999',
    shop_index,
    shop_type: '-999',
    sort_code: lxFilterParams.sort_code || '-999',
    sort_name: lxFilterParams.sort_name || '-999',
    recommended_reason: '-999',
    recommended_type: '-999',
    shop_rating: '-999',
    shop_status: data?.shopStatus?.shopStatusCode || '-999',
    tab_key: '-999',
    user_get_mode: 'delivery',
    ...paramsLxForLogs,
    ...logData,
  };
};

export const reportProductCardMc = (cid: string, data: any, shop_index: number, bizTraceId: string, lxFilterParams: LxFilterParams) => {
  if (!cid) {
    return;
  }
  const params = handleLXParam(data, shop_index, bizTraceId, lxFilterParams);
  Statistics.setTag && Statistics.setTag('sailor_c', {
    [cid]: {
      ...params,
      bid: ShopCardMc,
    },
  });
  Statistics.click(cid, ShopCardMc, params);
};

export const reportProductCardMv = (cid: string, data: any, shop_index: number, bizTraceId: string, lxFilterParams: LxFilterParams) => {
  if (!cid) {
    return;
  }
  const params = handleLXParam(data, shop_index, bizTraceId, lxFilterParams);
  Statistics.view(cid, ShopCardMv, params);
};
